import { analytics } from "@/telemetry/amplitude"
import StylesList, { StylesListType } from "./StylesList"
import { currentDisplayedStylesAtom } from "@/store/style/polarr-styles"
import { useAtomValue } from "jotai"
import { useSetAtom } from "jotai"
import { useEffect, useMemo } from "react"
import { StyleResponseDTO } from "@/api/dto/styles"
import { polarrStylesAtom } from "@/store/style/style-state"
import { showInternalStylesAtom } from "@/store/settings-state"

export const PolarrStylesPanel = (props: {
	onSelect: (style: StyleResponseDTO | undefined) => void
	selectedStyle: StyleResponseDTO | undefined
	isFullWidth?: boolean
	stylesListType: StylesListType
	onViewClicked?: (style: StyleResponseDTO) => void
}) => {
	const allPolarrStyles = useAtomValue(polarrStylesAtom)
	const setCurrentDisplayedStyles = useSetAtom(currentDisplayedStylesAtom)
	const showInternalStyles = useAtomValue(showInternalStylesAtom)

	const displayedStyles = useMemo(() => {
		if (showInternalStyles) {
			return allPolarrStyles.data.filter((style) => style.visibility !== "personal")
		}

		return allPolarrStyles.data.filter((style) => style.visibility === "public")
	}, [allPolarrStyles.data, showInternalStyles])

	useEffect(() => {
		setCurrentDisplayedStyles(displayedStyles)
	}, [displayedStyles, setCurrentDisplayedStyles])

	const handleSelect = (style: StyleResponseDTO, target?: EventTarget) => {
		analytics.trackEvent(
			{
				type: "click",
				label: "select_style",
				value: style.name,
			},
			target,
		)
		props.onSelect(style)
	}

	return (
		<div className="flex flex-col">
			<div className="flex-1">
				<StylesList
					type={props.stylesListType}
					styles={displayedStyles}
					onSelect={handleSelect}
					selectedStyle={props.selectedStyle}
					isFullWidth={props.isFullWidth}
					onViewClicked={props.onViewClicked}
				/>
			</div>
		</div>
	)
}
